/**
     * @desc 参会人入会check
可能产生业务错误码：510001、510002、510003、511003、511004、560001、560002、560003、560004。
三种check-in方式中，选择一种即可，当选择一种方式check-in时，另外两种方式的参数传递null或者不传。
     */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {}

export const method = 'POST';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey('/api/bs-vmeeting/v3/member/check-in', params, 'POST'),
    newValue,
    shouldRevalidate,
  );
}

export function useDeprecatedRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/v3/member/check-in',
    params,
    swrOptions,
    { method: 'POST' },
  );
}

export function request(
  params: Params,
  body: defs.client.CheckTheParameters,
  options?: any,
) {
  return PontCore.fetch(
    PontCore.getUrl('/api/bs-vmeeting/v3/member/check-in', params, 'POST'),
    {
      method: 'POST',

      body,
      ...options,
    },
  );
}
